import { getToken } from "../hooks/actions/sessionActions";

const normalizeJwt = (raw) => {
  if (raw == null || raw === "") return null;

  let value = raw;
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (trimmed.startsWith('"') && trimmed.endsWith('"')) {
      try {
        value = JSON.parse(trimmed);
      } catch {
        value = trimmed;
      }
    } else {
      value = trimmed;
    }
  }

  return String(value).replace(/^Bearer\s+/i, "").trim() || null;
};

/**
 * Token JWT do login (mesmo das outras APIs do SGU).
 * O backend aceita Authorization: Bearer ou header token.
 */
export const getAnalyticsJwt = () => {
  const fromUser = normalizeJwt(getToken());
  if (fromUser) return fromUser;

  if (typeof localStorage === "undefined") return null;
  return normalizeJwt(localStorage.getItem("token"));
};

export const getAnalyticsAuthHeaders = () => {
  const jwt = getAnalyticsJwt();
  if (!jwt) return null;

  return {
    Authorization: `Bearer ${jwt}`,
    token: jwt,
  };
};

export const hasAnalyticsAuth = () => Boolean(getAnalyticsJwt());
